module.exports = __webpack_public_path__ + "img/sunset_photo_not_found.3d26a5fa.png";